import options from './counter.component';


export default {
    selector: "dtEmulatorCounter",
    options
}